<app-toolbar></app-toolbar>
<div class="container">
    <app-user-form [formGroup]="userForm" [venues]="venues" [allowedRoles]="allowedRoles" [permitVenueAssignment]="permitVenueAssignment" [showAssignedVenues]="showAssignedVenues">
    </app-user-form>
    <div class="buttons">
        @if (allowReset) {
            <button mat-raised-button (click)="reset()">Reset</button>
        }
        
        @if (allowSave) {
            <button mat-raised-button color="primary" (click)="save()" [disabled]="!userForm.valid || !userForm.dirty">{{ saveButtonLabel }}</button>
        }

        @if (allowDelete) {
            <button mat-raised-button color="warn" (click)="delete()"> Delete </button>
        }
        
        @if (allowSendReset) {
            <button mat-raised-button color="primary" (click)="send_reset_email()">Send Password Reset Email</button>
        }
    </div>
</div>
